import {createContext} from 'react';

const FundingOpportunityContext = createContext();
export default FundingOpportunityContext;
